import './bootstrap';
import "../metronic/core/index";
import "../metronic/app/layouts/demo1";

// Form Submit Button Loading
$('form').on('submit', function(e) {
    e.preventDefault();
    var form = this;

    $('button.submit-form-btn').attr('disabled', true);
    $('button > .indicator-label').addClass('hidden');
    $('button > .indicator-progress').removeClass('hidden');

    form.submit();
});
